import { AuthTokenConstants } from '@customer-portal/shared/constants';
import { getRem } from '@customer-portal/shared/helpers/theme-utils';

export const SessionTimeout = {
  CHECK_INTERVAL_MS: 60 * 1000,
  BUFFER_TIME_MINUTES: 10,
  IDLE_THRESHOLD_TIME_MINUTES: 15,
  SHORT_TOKEN_THRESHOLD_MINUTES: 10,
  ACTIVITY_WINDOW_MINUTES: 1,
  SESSIOM_TIMEOUT_MODAL: 'session_timeout_modal',
};

export const SESSION_STORAGE_KEYS = [
  AuthTokenConstants.LAST_ACTIVITY_KEY,
  AuthTokenConstants.TOKEN_EXPIRY_KEY,
  AuthTokenConstants.TOKEN_DURATION_KEY,
  AuthTokenConstants.SHOW_MODAL_KEY,
] as const;

export const SESSION_TIMEOUT_DIALOG_CONFIG = {
  modal: true,
  showHeader: false,
  style: {
    width: 'auto',
  },
  breakpoints: {
    '960px': '50vw',
    '640px': '65vw',
  },
  contentStyle: {
    padding: getRem(32),
    borderRadius: getRem(10),
    minWidth: getRem(520),
    margin: `0 ${getRem(10)}`,
  },
  closable: false,
  closeOnEscape: false,
  dismissableMask: false,
};
